module Meevo.Plugins.AddOnGroup {
    "use strict";

    import IAddOnGroup = Meevo.Model.IAddOnGroup;
    import IBusyService = Meevo.Components.Busy.IBusyService;

    interface IServiceCategory {
        displayName: string;
        id: number
    }

    interface IService {
        displayName: string,
        id: number,
        selected?: boolean
    }

    /**
     * Main Section of AddOnGroup
     */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IAddOnGroup> {

        public serviceCategories: Array<IServiceCategory> = [];
        public services: IService[];
        public previousBusinessTypeId: Guid | string;
        public addOnServices: Model.AddOnServiceListItem[];
        public addOnServicesRequired: Model.AddOnServiceListItem[];
        public groupServicesExcludes: Model.AddOnServiceListItem[];
        public addOnServicesExcludes: Model.AddOnServiceListItem[];
        public addOnServicesRequiredExcludes: Model.AddOnServiceListItem[];

        public criteria = {
            includeActive: true,
            includeInactive: false
        };

        private busyService: IBusyService;
        private $q: angular.IQService;
        private userHasSingleBusinessType: Model.DataDetail;
        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService, userHasSingleBusinessType: Model.DataDetail) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

            this.busyService = params['busyService'];
            this.$q = params['$q'];
            this.userHasSingleBusinessType = userHasSingleBusinessType;
        }

        /**
         * The tab is activated
         */
        activate(): void {
            super.activate();
            this.getServicesAndServiceCategories();
            this.addOnServices = this.model.addOnServices.filter(addOn => !addOn.required);
            this.addOnServicesRequired = this.model.addOnServices.filter(addOn => addOn.required);

            this.groupServicesExcludes = [...this.addOnServices, ...this.addOnServicesRequired];
            this.addOnServicesExcludes = [...this.model.groupServices, ...this.addOnServicesRequired];
            this.addOnServicesRequiredExcludes = [...this.model.groupServices, ...this.addOnServices];
        }

        change = () : void => {

            if (!this.model) {
                return
            }
            this.groupServicesExcludes = [...(this.addOnServices || []), ...(this.addOnServicesRequired || [])];
            this.addOnServicesExcludes = [...(this.model.groupServices || []), ...(this.addOnServicesRequired || [])];
            this.addOnServicesRequiredExcludes = [...(this.model.groupServices || []), ...(this.addOnServices || [])];
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint)
                .then((data: IAddOnGroup) => {
                    this.model = data;

                    if (!this.identityService.inCentralOfficeMode() || (this.identityService.inCentralOfficeMode() && this.userHasSingleBusinessType)) {
                        this.getServicesAndServiceCategories();
                    }

                });
        }

        /**
         * User changes business type
         */
        businessTypeChanged(): void {
            if (this.model.businessTypeDetail) {
                this.model.groupServices = [];
                this.model.addOnServices = [];
                this.getServicesAndServiceCategories();
            }
        }

        /**
         * Get services and service categories by selected business type
         */
        getServicesAndServiceCategories(): void {
            if (this.identityService.inCentralOfficeMode()) {
                // When we are editing location owned item in CO mode, business type is always 'All Business Type' but we need location's business type
                // Alse we can't create an item with 'All business type' selected - it is a requirement
                //
                if (Model.Guard.isNothing(this.model.businessTypeDetail)) {
                    return;
                }
                let businessType = this.model.businessTypeDetail.id;
                this.criteria = _.extend(this.criteria, {
                    coBusinessTypeId: businessType,
                    coSearchResultFilter: Meevo.Model.CoSearchResultsFilter.All,
                    coSearchType: Meevo.Model.CoSearchType.CentralOffice
                });

                if (this.previousBusinessTypeId === this.model.businessTypeDetail.id) {
                    return;
                } else {
                    this.previousBusinessTypeId = this.model.businessTypeDetail.id;
                }
            } else {
                this.criteria = _.extend(this.criteria, {
                    coBusinessTypeId: this.identityService.businessTypeId
                });
            }

            this.busyService.start();
            this.$q.all([
                this.dataService.getListPaged('ServiceCategory', {
                    itemsPerPage: 10000,
                    criteria: this.criteria
                })
                    .then((categories: Array<IServiceCategory>) => {
                        this.serviceCategories = categories;
                    }),
                this.dataService.getListPaged('Service', {
                    itemsPerPage: 10000,
                    criteria: this.criteria
                })
                    .then((services: Array<IService>) => {
                        services.forEach((service: IService) => {
                            service.selected = false;
                        });
                        this.services = services;
                    })
            ])
                .finally(() => {
                    this.busyService.stop();
                });
        }

        preSave() {
            super.preSave();
            this.addOnServicesRequired.forEach(addOnRequired => addOnRequired.required = true);
            this.model.addOnServices = [...this.addOnServices, ...this.addOnServicesRequired]
        }
    }
}